import type { ReactNode } from 'react';

export const symbol_vpn_key_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M792-83 497-377h-6q-26 60-78 98.5T280-240q-100 0-170-70T40-480q0-66 35-125t102-92l-95-95q-9-9.07-9-21.53Q73-826 82.05-835q9.06-9 21.5-9 12.45 0 21.45 9l710 710q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q801-74 792-83ZM692-353l-84-84h84v84Zm100 100-47-47h9v-136.82h106V-523H522l-60-60h398q24.75 0 42.38 17.62Q920-547.75 920-523v86q0 24.75-17.62 42.37Q884.75-377 860-377h-46v77q0 15.11-6.5 26.86T792-253Zm-512-47q56 0 103.5-36t63.5-90L223-651q-60 20-91.5 67.5T100-480q0 75 52.5 127.5T280-300Zm0-112q-29 0-48.5-19.5T212-480q0-29 19.5-48.5T280-548q29 0 48.5 19.5T348-480q0 29-19.5 48.5T280-412Zm281-72Zm-287 8Z"
		/>
	</svg>
);
